import { useEffect, useState } from "react";
import RepoItem from "./RepoItem";
import FlipMove from "react-flip-move";

const RepoList = ({ repos }) => {
  const [sortType, setSortType] = useState("stars");
  const [topRepos, setTopRepos] = useState([]);
  const [limit, setLimit] = useState(10);
  const sortTypes = ["stars", "forks", "size"];
  const limitTypes = [10, 25, 50, 100];
  const changeRepoSort = (sortType, limit) => {
    setSortType(sortType, limit);
    setLimit(limit);
    // toggleDropdown();
  };
  const getTopRepos = (type, limit) => {
    const LIMIT = limit;
    const map = {
      stars: "stargazers_count",
      forks: "forks_count",
      size: "size",
    };
    const sortProperty = map[type];
    const sorted = repos
      .filter((repo) => !repo.fork)
      .sort((a, b) => b[sortProperty] - a[sortProperty])
      .slice(0, LIMIT);

    setTopRepos(sorted);
  };
  useEffect(() => {
    getTopRepos(sortType, limit);
  }, [sortType, limit, repos]);

  return (
    <div className=" ">
      <div className="rounded-lg shadow-lg card dark:bg-base-100">
        <div className="card-body">
          <h2 className="text-3xl my-4 font-bold card-title">
            Latest Repositories sorted by
            <div class="dropdown dropdown-hover text-xl">
              <div tabindex="0" class="m-1 btn">
                {sortType}
              </div>
              <ul
                tabIndex="0"
                class="p-2 shadow menu dropdown-content bg-base-100 rounded-box w-30"
              >
                {sortTypes.map((type, i) => (
                  <li key={i}>
                    <a>
                      <button onClick={() => changeRepoSort(type, limit)}>
                        {type}
                      </button>
                    </a>
                  </li>
                ))}
              </ul>
            </div>
            and Limited to
            <div class="dropdown dropdown-hover text-xl">
              <div tabindex="1" class="m-1 btn">
                {limit}
              </div>
              <ul
                tabIndex="1"
                class="p-2 shadow menu dropdown-content bg-base-100 rounded-box w-30"
              >
                {limitTypes.map((limitType, i) => (
                  <li key={i}>
                    <a>
                      <button
                        onClick={() => changeRepoSort(sortType, limitType)}
                      >
                        {limitType}
                      </button>
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          </h2>
          <div className="grid lg:grid-cols-3 lg:gap-3 md:grid-cols-2 md:gap-2">
            {topRepos.map((repo) => (
              <FlipMove>
                <div key={repo.id}>
                  <RepoItem repo={repo} />
                </div>
              </FlipMove>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default RepoList;
